import { observable, computed, runInAction, action } from 'mobx';
import { get } from '../utils';
// import { burialPoint } from '../operates';
// import store from '../store';

class RankList {
    static PAGE_SIZE = 20;
    private route: string;
    private params: any;
    private header: Object;
    private _that: any;

    @observable
    public firstFetched: boolean = false;
    @observable
    public isHomeLast: boolean = true;
    @observable
    public isEmpty: boolean = false;
    @observable
    public lists: any[] = [];
    @observable
    public page: any = 1;
    @observable
    public isReady: boolean = false;
    @observable
    public cursor: any = 0;
    @observable
    private isLastPage: boolean = true;

    constructor(params: any, header?: Object, _that?: any) {
        this.route = params.url;
        this.params = params;
        this.header = header || {};
        this._that = _that || {};
    }

    @computed
    get canFetch() {
        if (this.isEmpty) {
            return false;
        }
        return !this.isLastPage;
    }

    async fetch(page, callback, errs?) {
        if (this.route == 'newproduct/carts/v1') {
            RankList.PAGE_SIZE = 200;
        } else {
            RankList.PAGE_SIZE = 20;
        }
        let obj = Object.assign({
            count: RankList.PAGE_SIZE,
            cursor: this.cursor
        }, this.params);
        if (this.cursor == null && page != 1) {
            return callback && callback([], null); // 返回库存和页码
        }
        if (page == 1) {
            obj.cursor = 0;
        }
        get(this.route, obj).then((d) => {
            this.isReady = true;
            let data;
            if (d.data) {
                data = d.data.list;
                this.cursor = d.data.cursor;
                if (this.route == 'newproduct/carts/v1/skuIds' || this.route == 'address/v1/bannerList') {
                    data = d.data;
                }
                runInAction(() => {
                    if (page == 1) {
                        this.lists = [];
                        this.isEmpty = data.length == 0;
                    }
                    this.firstFetched = true;
                    this.isLastPage = data.length < RankList.PAGE_SIZE;
                    let price = 0, len = 0;
                    data.forEach((item) => {
                        item.key = item.ciId + '' + Date.now();
                        price += (item.cartPrice * 100); // 合计
                        if (this.route == 'newproduct/carts/v1') {
                            item.isquan = false; // 默认没选中
                            item.isEditQuan = false; // 默认编辑没选中
                        }
                        if (this.route == 'newproduct/carts/v1' && item.skuItem.inventory <= 0) { // 判断库存和购物车页面
                            len++;
                        }
                        if (this.route == 'newproduct/carts/v1' && item.skuItem.status == 5) { // 判断库存和购物车页面
                            len++;
                        }
                        this.lists.push(item);
                    });
                    if (this.route == 'newproduct/carts/v1' || this.route == 'newproduct/carts/v1/skuIds') { // 购物车页面和购物车结算页
                        callback && callback(data, price / 100, len); // 返回列表 价格 和库存为0
                    } else {
                        callback && callback(data, this.cursor); // 返回库存和页码
                    }
                    // if (this.route == 'searchapi/search' || this.route.indexOf('searchapi/category/3') > -1) {
                    //     burialPoint('burialpoint/logSearchlist', {body: JSON.stringify(this._setBurialPointPage(d.data.total))}); //页面级埋点
                    // }
                });
            } else {
                callback && callback([]);
                this.firstFetched = true;
            }
        }).catch((err) => {
            errs && errs(err);
        });
    }

    // 埋点 - 搜索结果
    // private _setBurialPointPage(total: any): Object {
    //     let headerObj: object = {
    //         user: {
    //             userType: 1,
    //             serviceType: 'C',
    //             clientType: store.status.gameApp ? 3 : 4,
    //             osTypeId: _equipmentType(),
    //             appId: store.status.gameId ? store.status.gameId : null,
    //         },
    //         page: {
    //             pageId: 'search',
    //             categoryId: getParam('id', this._that) ? getParam('id', this._that) : null,
    //             resultnum: total,
    //             keyword: !getParam('id', this._that) ? getParam('val', this._that) ? getParam('val', this._that) : null : null,
    //         }
    //     };
    //     return headerObj;
    // }

    @computed
    get list() {
        return this.lists.slice();
    }

    // 购物车排序
    @action('排序')
    public shopSort(data: any): void {
        this.lists = data;
    }
}

export default RankList;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/RankList.ts